import { useMemo } from 'react';
import type { Photo_Base } from '~/common/typescript/apis/PhotoAPIs';
import { parseMetadata } from '../utils/freePhotoUtils';

export interface PhotoMarker {
  photo: Photo_Base;
  coordinates: [number, number];
  compassHeading: number;
}

/**
 * Custom hook to prepare photo markers for map display
 * @param photos - Array of unified Photo objects
 * @returns Array of photo markers with valid coordinates
 */
export const useFreePhotoMapClusters = (photos: Photo_Base[]): PhotoMarker[] => {
  return useMemo(() => {
    const markers: PhotoMarker[] = [];

    photos.forEach((photo) => {
      if (!photo.location) return;

      const { lat, lng } = photo.location;
      
      // Validate coordinates
      if (!isFinite(lat) || !isFinite(lng)) return;
      if (lat < -90 || lat > 90) return;
      if (lng < -180 || lng > 180) return;

      markers.push({
        photo,
        coordinates: [lng, lat],
        compassHeading: photo.location.compassHeading || 0,
      });
    });

    return markers;
  }, [photos]);
};
